import { RefObject, useEffect, useState } from "react";
import theme from "theme";
import { parseSafeInt } from "Backend";

export default function PageNumberInput({
  value,
  updateNumber,
  inputRef,
  min,
  max,
  dataPendo,
}: {
  value: number;
  updateNumber: (value: number) => void;
  inputRef: RefObject<HTMLInputElement>;
  min: number;
  max: number;
  dataPendo?: string;
}) {
  const [strState, setStrState] = useState<string>(`${value || ""}`);

  const [isHovered, setIsHovered] = useState<boolean>(false);

  useEffect(() => {
    if (value !== parseInt(strState, 10)) {
      setStrState(`${value}`);
    }
  }, [value]);

  return (
    <form
      className="flex items-center"
      onSubmit={(evt) => {
        evt.preventDefault();
        evt.target[0].blur();
      }}>
      <input
        data-pendo={dataPendo}
        name="pageNumber"
        ref={inputRef}
        type="number"
        min={min}
        max={max}
        style={{
          width: "32px",
          height: "20px",
          borderStyle: "none",
          cursor: "text",
          fontSize: "12px",
          marginRight: "3px",
          fontWeight: "bold",
          textAlign: "center",
          color: theme.palette.grey["400"],
          backgroundColor: isHovered ? theme.palette.grey["50"] : "white",
          outlineColor: theme.palette.primary.main,
          appearance: "textfield",
          MozAppearance: "textfield",
          WebkitAppearance: "textfield",
        }}
        className="pageNumberInput"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onFocus={(evt) => evt.target.select()}
        onClick={(evt) => evt.currentTarget.select()}
        onBlur={(evt) => {
          const newVal = parseSafeInt(evt.target.value);
          if (newVal !== undefined && newVal >= min && newVal <= max) {
            updateNumber(newVal);
          } else {
            setStrState(`${value}`);
          }
        }}
        onChange={(evt) => {
          const v = evt.target.value;
          if (v !== undefined) {
            setStrState(`${v}`);
          }
        }}
        value={strState}
      />
    </form>
  );
}
